import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'getTooltipPlusValue'
})
export class GetTooltipPlusValuePipe implements PipeTransform {
  transform(multipleTooltipValue: Array<any>, type: string = ""): any {
    let finalValue: string = "";
    if (!type) {
      multipleTooltipValue.map((selectedItem: any, index: number) => {
        finalValue += selectedItem.value;
        if (index < (multipleTooltipValue.length - 1)) {
          finalValue += ", "
        }
      })
    } else {

    }
    return finalValue;
  }
}
